import { isNil } from "lodash";

import { IDropdownItem } from "@ryde/shared";

export const hasCurrentSiteId = (
  currentSiteId?: string | number | null,
): boolean => !isNil(currentSiteId) && currentSiteId !== "";

export const shouldLockForeignSiteAsReadonly = ({
  currentSiteId,
  allowedSiteIds,
}: {
  currentSiteId?: string | number | null;
  allowedSiteIds?: (string | number | boolean)[];
}): boolean => {
  if (allowedSiteIds === undefined || !hasCurrentSiteId(currentSiteId)) {
    return false;
  }

  return !allowedSiteIds.some(id => String(id) === String(currentSiteId));
};

export const resolveLockedSiteLabel = ({
  siteName,
  currentSiteId,
  allowedItems,
}: {
  siteName?: string | null;
  currentSiteId?: string | number | null;
  allowedItems?: IDropdownItem[];
}): string => {
  const trimmedName = siteName?.trim();

  if (trimmedName) {
    return trimmedName;
  }

  const fromItems = allowedItems?.find(
    item => String(item.value) === String(currentSiteId),
  )?.label;

  if (fromItems) {
    return fromItems;
  }

  return hasCurrentSiteId(currentSiteId) ? String(currentSiteId) : "";
};
